import { invokeApi } from "../bl_libs/invokeApi";

export const get_support_tickets_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/list`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_multiple_status_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/update_multiple_status`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const update_support_tickets_api = async (data, ticket_id) => {
  const requestObj = {
    path: `api/support_tickets/update/${ticket_id}`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};


export const get_case_count_api = async () => {
  const requestObj = {
    path: `api/support_tickets/case_count`,
    method: "GET",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};

export const get_ticket_detail_api = async (ticket_id) => {
  const requestObj = {
    path: `api/support_tickets/detail/${ticket_id}`,
    method: "GET",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};


export const add_support_tickets_api = async (data) => {
  const requestObj = {
    path: `api/support_tickets/create`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
export const get_ticket_trash_api = async (ticket_id) => {
  const requestObj = {
    path: `api/support_tickets/trash/${ticket_id}`,
    method: "POST",
    headers: {
      "Authorization": `Bearer ${localStorage.getItem("token")}`,
    },
  };
  return invokeApi(requestObj);
};